import { Transport } from "../data/api/types/schedule";
import { ReportPrinter } from "./ReportPrinter";
import companyLogoPng from "./company-logo.png";
import electroLogoPng from "./electro-logo.png";

type LogoCacheEntry = {
  data: Uint8Array | null;
  type: string | null;
  size: {
    width: number;
    height: number;
  } | null;
};

const logoCache: Record<Transport, LogoCacheEntry> = {
  A: {
    data: null,
    type: null,
    size: null,
  },
  TM: {
    data: null,
    type: null,
    size: null,
  },
  TB: {
    data: null,
    type: null,
    size: null,
  },
};

export async function printLogo(
  printer: ReportPrinter,
  selectedTransport: Transport
) {
  const cacheEntry = logoCache[selectedTransport];

  if (
    cacheEntry.data === null ||
    cacheEntry.type === null ||
    cacheEntry.size === null
  ) {
    const logoRequest = await fetch(
      selectedTransport === "TM" || selectedTransport === "TB"
        ? electroLogoPng
        : companyLogoPng
    );
    const logo = await logoRequest.blob();
    //if (logo.type !== "image/png") {
    //  throw new Error(`Unsupported image format: ${logo.type}`);
    //}
    const logoBuffer = await logo.arrayBuffer();
    const logoData = new Uint8Array(logoBuffer);
    //const imageSize = size(logoData);
    const imageInfo = printer.doc.getImageProperties(logoData);

    cacheEntry.data = logoData;
    cacheEntry.type = logo.type;
    //cacheEntry.size = imageSize;
    cacheEntry.size = { width: imageInfo.width, height: imageInfo.height };
  }

  if (selectedTransport === "A") {
    printer.doc.addImage(
      cacheEntry.data,
      cacheEntry.type,
      printer.pageMarginX,
      printer.pageMarginY - 6,
      (printer.printableWidth * 2) / 3,
      ((printer.printableWidth * 2) / 3) *
      (cacheEntry.size.height / cacheEntry.size.width)
    );
  } else {
    printer.doc.addImage(
      cacheEntry.data,
      cacheEntry.type,
      printer.pageMarginX * 2,
      printer.pageMarginY - 6,
      (printer.printableWidth * 2) / 9,
      ((printer.printableWidth * 2) / 9) *
      (cacheEntry.size.height / cacheEntry.size.width)
    );
  }

  return {
    imageWidth: cacheEntry.size.width,
    imageHeight: cacheEntry.size.height,
    addressOffsetX:
      selectedTransport === "A"
        ? (printer.printableWidth * 2) / 3
        : (printer.printableWidth * 2) / 9 + printer.pageMarginX,
    addressOffsetY:
      selectedTransport === "A"
        ? ((printer.printableWidth * 2) / 3) *
        (cacheEntry.size.height / cacheEntry.size.width)
        : ((printer.printableWidth * 2) / 9) *
        (cacheEntry.size.height / cacheEntry.size.width) +
        10,
  };
}
